import React, { useEffect, useState, useRef } from 'react';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { FaUpload, FaArrowLeft } from 'react-icons/fa';
import '../../../assets/css/Category/AddEditCategory.css';
const API_BASE_URL = process.env.REACT_APP_API_URL;

export default function AddEditCategory() {
  const { id } = useParams();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [form, setForm] = useState({
    name: '',
    route: '',
    description: '',
    remarks: '',
    status: true,
    image: null,
    imageUrl: ''
  });

  // Load category data if editing
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (id && token) {
      axios.get(`${API_BASE_URL}/api/categories/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(res => {
          const imgPath = res.data.image
            ? `${API_BASE_URL}/uploads/${res.data.image}`
            : '';
          setForm(prev => ({
            ...prev,
            ...res.data,
            image: null,
            imageUrl: imgPath
          }));
        })
        .catch(err => console.error("Error fetching category:", err));
    }
  }, [id]);

  // Handle field changes
  const handleChange = e => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'checkbox') {
      setForm({ ...form, [name]: checked });
    } else if (type === 'file') {
      const file = files[0];
      if (file) {
        setForm({ ...form, image: file, imageUrl: URL.createObjectURL(file) });
      }
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  // Submit form
  const handleSubmit = async e => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    const data = new FormData();

    Object.entries(form).forEach(([key, value]) => {
      if (key === 'imageUrl') return;
      if (value !== null) data.append(key, value);
    });

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      };

      if (id) {
        await axios.put(`${API_BASE_URL}/api/categories/${id}`, data, config);
      } else {
        await axios.post(`${API_BASE_URL}/api/categories`, data, config);
      }
      navigate('/category');
    } catch (err) {
      console.error("Error saving category:", err);
      if (err.response?.status === 401) {
        localStorage.removeItem('token');
        navigate('/login');
      }
    }
  };

  // Trigger file input
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-end mb-3">
        <Button variant="dark" onClick={() => navigate('/category')}>
          <FaArrowLeft className="me-2" />
          Back to Category
        </Button>
      </div>

      <div className="category-heading mb-4 p-3 text-white rounded">
        <h4 className="mb-0">{id ? 'Edit' : 'Add'} Category</h4>
      </div>

      <Card className="p-4 shadow-sm category-card">
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3 align-items-start">
            {/* Image Upload Column */}
            <Col md={3} className="text-center">
              <div className="image-upload-box" onClick={triggerFileInput}>
                {form.imageUrl ? (
                  <img src={form.imageUrl} alt="Preview" className="preview-image" />
                ) : (
                  <div className="upload-icon">
                    <FaUpload size={30} />
                    <div>Click to Upload</div>
                  </div>
                )}
              </div>
              <Form.Control
                type="file"
                name="image"
                onChange={handleChange}
                ref={fileInputRef}
                className="d-none"
              />
            </Col>

            {/* Name and Route Column */}
            <Col md={5}>
              <Form.Group className="mb-3">
                <Form.Label>Name *</Form.Label>
                <Form.Control
                  name="name"
                  required
                  value={form.name}
                  onChange={handleChange}
                  className="custom-input"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Route *</Form.Label>
                <Form.Control
                  name="route"
                  required
                  value={form.route}
                  onChange={handleChange}
                  className="custom-input"
                />
              </Form.Group>
            </Col>

            {/* Description and Remarks Column */}
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                  className="custom-input"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Remarks</Form.Label>
                <Form.Control
                  name="remarks"
                  value={form.remarks}
                  onChange={handleChange}
                  className="custom-input"
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Status switch and action buttons */}
          <Row className="mb-3">
            <Col className="d-flex justify-content-end align-items-center gap-3">
              <Form.Label>Status</Form.Label>
              <Form.Check
                type="switch"
                id="status-switch"
                label={
                  <span className={form.status ? 'text-success' : 'text-danger'}>
                    {form.status ? 'Active' : 'Inactive'}
                  </span>
                }
                name="status"
                checked={form.status}
                onChange={handleChange}
                className={`custom-switch ${form.status ? 'active' : 'inactive'}`}
              />
              <Button variant="secondary" onClick={() => navigate('/category')}>
                Cancel
              </Button>
              <Button variant="success" type="submit">
                Save
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}
